import React from 'react';
import styled from 'styled-components';

import ExpandableArrow from '#/components/basic/icons/ExpandableArrow';
import { formatMarketHoursTooltip } from '#/components/markets/intermittent/intermittentMarkets';
import MarketSessionStatusDot from '#/components/markets/intermittent/MarketSessionStatusDot';
import { useIntermittentMarketSessionDisplay } from '#/components/markets/intermittent/useIntermittentMarketSessionDisplay';
import { CoinIcon } from '#/config/coinIcons/CoinIcon';
import { useSelectMarketData } from '#/reduxState/markets/listed/listedMarketsUtils';
import { openMarketsSidebar } from '#/reduxState/markets/marketsSidebar';
import { useSelector, staticDispatch } from '#/reduxState/store';

import MarketsTickersScreen from './marketsScreen/MarketsTickersScreen';

const TitleWithStatusWrap = styled.div`
  display: flex;
  align-items: center;
`;

const Heading = styled.h2<{ padding?: string }>`
  font-weight: normal;
  font-size: var(--small);
  display: flex;
  align-items: center;
  color: var(--gray4a);
  ${props => (props.padding ? `padding: ${props.padding}` : 'padding: 8px 0;')};
  cursor: pointer;
`;

const White = styled.div`
  color: var(--white);
`;

const StatusDotWrap = styled.span`
  display: flex;
  margin-left: 4px;
`;

function MarketSelectorMobile() {
  const currentMarket = useSelector(state => state.markets.currentMarket);
  const { base, quote } = currentMarket;

  const marketData = useSelectMarketData(currentMarket.pair);
  const session = useIntermittentMarketSessionDisplay(marketData, 'every-tick');

  return (
    <>
      <MarketsTickersScreen />
      <TitleWithStatusWrap>
        <Heading onClick={() => staticDispatch(openMarketsSidebar())}>
          {base && <CoinIcon symbol={base} size="16px" />}&nbsp;{' '}
          <White>{base}</White>-{quote}
          &nbsp;
          <ExpandableArrow expanded={false} />
        </Heading>
        {session && (
          <StatusDotWrap>
            <MarketSessionStatusDot
              status={session.status}
              transitionVeryClose={session.transitionVeryClose}
              tooltip={formatMarketHoursTooltip(marketData)}
            />
          </StatusDotWrap>
        )}
      </TitleWithStatusWrap>
    </>
  );
}

export default MarketSelectorMobile;
